(function (module) {
    'use strict';

    function ToolbarController ($mdSidenav) {

        function toggleSidenav (sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        this.$onInit = () => {
            this.bodyEl = angular.element('body');
            this.toggleSidenav = toggleSidenav;
        };
    }

    function config ($translatePartialLoaderProvider) {
        $translatePartialLoaderProvider.addPart('/js/components/toolbar');
    }

    module
        .config(config)
        .controller('ToolbarController', ToolbarController);

})(angular.module('rocket.components'));
